import { createSlice, isAnyOf, PayloadAction } from '@reduxjs/toolkit';
import { updateSearchMeta } from 'shared/thunks/searchMeta';
import { ISearchMeta, TLoadableSearchMeta } from 'shared/types/searchMeta';

const initialState: TLoadableSearchMeta = {
  data: {} as ISearchMeta,
  isLoading: false,
};

export const searchMetaSlice = createSlice({
  name: 'searchMeta',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(updateSearchMeta.pending, state => {
        state.isLoading = true;
      })
      .addCase(updateSearchMeta.fulfilled, (state, action: PayloadAction<ISearchMeta>) => {
        state.data = action.payload;
      })
      .addMatcher(isAnyOf(updateSearchMeta.fulfilled, updateSearchMeta.rejected), state => {
        state.isLoading = false;
      });
  },
});

export const { reducer: searchMetaReducer, name: searchMetaReducerName } = searchMetaSlice;
